var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserSearchLine = function SvgUserSearchLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 13.802v1.8a5.4 5.4 0 0 0-5.4 5.4H4.8a7.2 7.2 0 0 1 7.2-7.2m0-.9a5.4 5.4 0 0 1-5.4-5.4c0-2.984 2.416-5.4 5.4-5.4 2.983 0 5.4 2.416 5.4 5.4 0 2.983-2.416 5.4-5.4 5.4m0-1.8c1.989 0 3.6-1.611 3.6-3.6s-1.611-3.6-3.6-3.6a3.6 3.6 0 0 0-3.6 3.6 3.6 3.6 0 0 0 3.6 3.6m8.501 8.128 1.354 1.354-1.273 1.273-1.353-1.354A3.6 3.6 0 1 1 20.5 19.23Zm-3.101-.028a1.8 1.8 0 1 0 0-3.601 1.8 1.8 0 0 0 0 3.6Z"
  })));
};
export default SvgUserSearchLine;